var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIllustrationWavingGuy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 156,
    height: 349,
    viewBox: "0 0 156 349",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M124.64 116.29C127.697 115.599 130.168 115.012 131.76 114.551C127.425 109.525 125.687 107.012 122.86 103.431C122.86 103.431 123.425 107.326 124.619 116.248L124.64 116.29ZM126.734 131.912V132.101C129.812 153.587 133.414 177.336 133.666 181.964L51.4472 181.817C51.7194 167.032 57.7298 125.63 61.1853 104.332C59.3633 105.086 27.301 116.897 23.4896 113.023V112.918C20.8299 97.6722 17.4164 81.0442 15.4688 68.5208L24.4738 64.6047C25.877 68.9815 31.992 85.0022 35.8244 93.4C44.4159 85.4912 53.7985 78.4875 63.824 72.4998C70.1066 69.1072 80.3682 69.526 80.3682 69.526C80.4995 68.5618 80.8662 67.6447 81.436 66.8558C82.0058 66.0668 82.7611 65.4304 83.6351 65.0025L84.2425 64.7722C91.258 62.8455 104.116 64.2277 105.729 65.212C107.079 66.2567 108.027 67.7366 108.41 69.4004C108.41 69.4004 125.519 71.9134 130.545 76.039C130.545 76.039 145.791 96.8764 153.414 113.232C156.22 119.242 155.152 122.928 150.042 125.797C147.11 127.766 137.058 130.111 126.776 131.912H126.734ZM98.3574 123.536C98.7344 122.53 96.4098 119.703 93.6664 119.473H93.3941L94.4412 110.51C94.4412 109.4 90.2528 108.415 85.2058 108.415C80.1588 108.415 75.9913 109.337 75.9913 110.51C75.9943 110.639 76.0383 110.763 76.1169 110.866L77.2478 120.813C77.2384 120.869 77.2384 120.925 77.2478 120.981C76.9458 120.961 76.6432 121.007 76.3608 121.116C76.0784 121.225 75.8229 121.394 75.6119 121.611C75.4009 121.827 75.2395 122.088 75.1387 122.373C75.0379 122.658 75.0001 122.962 75.028 123.263C75.1325 123.968 75.4037 124.638 75.8189 125.217C76.2341 125.796 76.7814 126.268 77.4153 126.593C77.1373 126.532 76.8492 126.532 76.5713 126.594C76.2933 126.656 76.0324 126.778 75.8067 126.952C75.5811 127.125 75.3963 127.346 75.2654 127.599C75.1344 127.852 75.0605 128.131 75.0489 128.415C75.1826 129.051 75.4622 129.646 75.8656 130.155C76.269 130.664 76.7852 131.072 77.3735 131.347C77.117 131.262 76.8444 131.238 76.5771 131.277C76.3099 131.316 76.0554 131.417 75.8338 131.572C75.6123 131.726 75.4298 131.93 75.3008 132.167C75.1718 132.405 75.0999 132.669 75.0908 132.939C75.0908 133.944 76.5148 135.2 79.0698 136.08V136.583L79.698 142.216C81.447 142.727 83.2581 142.995 85.0801 143.012C87.0656 142.971 89.0399 142.704 90.9649 142.216L91.5512 136.897V136.562C94.1878 136.081 96.7696 135.337 99.2579 134.342L99.6139 134.049C97.7501 132.185 96.4098 126.153 98.3993 123.536H98.3574Z",
    fill: "#0C1356"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M83.8366 343.812V343.686H49.9314C48.9471 338.115 53.0937 335.665 57.4706 335.163C66.5804 334.094 77.5121 328.294 79.2084 327.938H97.8887C97.8887 331.163 97.8887 333.131 97.8887 333.529V333.78C95.7546 334.433 93.5687 334.902 91.3548 335.183C86.9779 335.749 82.8105 338.199 83.8366 343.812Z",
    fill: "#0C1356"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M83.8291 343.665V343.79C82.803 338.178 86.9704 335.728 91.3473 335.225C93.5613 334.944 95.7471 334.475 97.8812 333.822C105.064 331.728 111.787 328.272 113.085 328H132.247C132.247 336.565 132.142 342.241 132.247 343.707L83.8291 343.665Z",
    fill: "#0C1356"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M92.8849 27.0433C93.1145 27.0595 93.3287 27.165 93.4814 27.3373C93.6341 27.5096 93.7132 27.7349 93.7016 27.9648C93.6803 28.1962 93.5703 28.4105 93.3947 28.5627C93.2191 28.7149 92.9914 28.7933 92.7593 28.7815C92.5295 28.7602 92.3173 28.6495 92.1685 28.4732C92.0196 28.2969 91.946 28.0692 91.9635 27.8391C91.9686 27.7253 91.9969 27.6137 92.0466 27.5111C92.0964 27.4086 92.1665 27.3173 92.2528 27.2428C92.339 27.1683 92.4396 27.1122 92.5483 27.0779C92.657 27.0436 92.7715 27.0318 92.8849 27.0433Z",
    fill: "#0C1356"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M81.3783 26.73C81.5862 26.7741 81.7711 26.8919 81.8989 27.0618C82.0266 27.2316 82.0886 27.442 82.0733 27.6539C82.0579 27.8659 81.9664 28.0651 81.8155 28.2148C81.6647 28.3645 81.4648 28.4545 81.2527 28.4682C81.1273 28.4763 81.0017 28.4575 80.8842 28.413C80.7667 28.3684 80.6601 28.2992 80.5717 28.2101C80.4832 28.1209 80.4148 28.0138 80.3712 27.896C80.3275 27.7782 80.3096 27.6524 80.3187 27.5271C80.3278 27.4018 80.3636 27.2799 80.4237 27.1696C80.4838 27.0593 80.5669 26.9631 80.6673 26.8876C80.7677 26.8121 80.8831 26.7589 81.0057 26.7318C81.1284 26.7046 81.2554 26.704 81.3783 26.73Z",
    fill: "#0C1356"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M61.2543 104.414C59.4323 105.168 27.37 116.979 23.5586 113.105",
    stroke: "#0C1356",
    strokeWidth: 0.86,
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M104.297 20.0584C104.046 18.2992 103.773 16.2469 103.375 14.1527C102.886 10.7286 101.547 7.48148 99.4802 4.70784C94.6844 -0.653324 89.5327 1.35711 85.1558 5.85965C83.8998 7.16082 82.7512 8.56153 81.7213 10.0481C78.5899 14.5316 76.1802 19.478 74.5801 24.7075C72.7372 31.9535 82.9569 48.2883 85.9097 49.461C86.2634 49.5905 86.6278 49.6886 86.9987 49.7542C91.3128 50.5709 96.7996 46.7176 98.6425 42.9271",
    stroke: "#0C1356",
    strokeWidth: 0.86,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M105.782 65.2938C105.782 52.8961 106.452 41.6293 105.426 29.2734",
    stroke: "#0C1356",
    strokeWidth: 0.86,
    strokeMiterlimit: 10
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M87.0996 49.2266C87.0896 49.3939 87.0896 49.5618 87.0996 49.7292C86.0106 54.6087 85.7175 60.64 83.707 64.975",
    stroke: "#0C1356",
    strokeWidth: 0.86,
    strokeMiterlimit: 10
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M102.574 22.2545C103.091 21.4891 103.696 20.7863 104.375 20.1603C109.276 15.9719 112.522 25.2911 110.511 27.9298C109.877 28.5969 109.058 29.0606 108.16 29.2619C107.261 29.4632 106.323 29.3932 105.464 29.0607C105.07 28.9531 104.69 28.7984 104.333 28.6",
    stroke: "#0C1356",
    strokeWidth: 0.86,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M81.7612 9.99994C80.5884 9.87428 64.3164 6.58638 66.641 2.02101C67.9813 -0.575804 76.6094 2.18855 85.1957 5.7487C93.3631 9.14131 101.53 13.246 103.415 14.1255L103.708 14.2512",
    stroke: "#0C1356",
    strokeWidth: 0.86,
    strokeMiterlimit: 10
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M91.2266 23.179C92.0821 22.9156 92.9881 22.86 93.8694 23.0166C94.7508 23.1732 95.5821 23.5375 96.2946 24.0795",
    stroke: "#0C1356",
    strokeWidth: 0.86,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M105.238 23.9375C106.138 24.7446 107.297 25.2049 108.505 25.2359",
    stroke: "#0C1356",
    strokeWidth: 0.86,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M79.8516 23.5537C81.2337 22.9254 84.3541 23.093 84.9196 24.4542C85.8201 26.6531 84.4798 31.2185 83.9143 33.8362C83.5164 35.6163 82.8882 39.0718 86.0085 38.1503",
    stroke: "#0C1356",
    strokeWidth: 0.86,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M90.2978 42.5463C89.9254 42.9481 89.4677 43.2613 88.9583 43.4629C88.449 43.6645 87.9009 43.7493 87.3544 43.7111C86.8079 43.673 86.277 43.5128 85.8006 43.2423C85.3242 42.9719 84.9145 42.5981 84.6016 42.1484",
    stroke: "#0C1356",
    strokeWidth: 0.86,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M98.3922 277.242C98.2037 299.566 97.9314 318.833 97.8477 327.985C97.8477 331.21 97.8477 333.178 97.8477 333.576",
    stroke: "#0C1356",
    strokeWidth: 0.86,
    strokeMiterlimit: 10
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M119.234 188.516C118.983 197.479 125.119 202.882 132.784 205.081C134.982 205.706 137.244 206.078 139.527 206.191",
    stroke: "#0C1356",
    strokeWidth: 0.86,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M132.164 343.682C132.164 342.216 132.164 336.54 132.164 327.975C132.394 301.902 132.918 248.856 132.688 205.087C132.688 197.297 132.583 189.799 132.478 182.805",
    stroke: "#0C1356",
    strokeWidth: 0.86,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M83.8281 343.81L132.162 344.02C132.162 344.02 132.162 343.873 132.162 343.727",
    stroke: "#0C1356",
    strokeWidth: 0.86,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M86.7262 199.102C87.8771 225.489 91.8223 251.681 98.4956 277.236C102.914 295.037 108.045 312.063 112.988 327.77V327.979C111.689 328.251 104.967 331.728 97.7836 333.801C95.6495 334.454 93.4636 334.923 91.2497 335.204C86.8728 335.707 82.7053 338.157 83.7315 343.769",
    stroke: "#0C1356",
    strokeWidth: 0.86,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M53.1096 182.07C54.408 239.849 67.057 289.503 79.1616 327.953C77.4652 328.309 66.5963 334.11 57.4237 335.178C53.0468 335.68 48.9003 338.131 49.8845 343.701H84.2923",
    stroke: "#0C1356",
    strokeWidth: 0.86,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M78.3867 327.984H79.1616H97.5278",
    stroke: "#0C1356",
    strokeWidth: 0.86,
    strokeMiterlimit: 10
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M113.062 327.984H113.083H132.204",
    stroke: "#0C1356",
    strokeWidth: 0.86,
    strokeMiterlimit: 10
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M132.162 344.017V347.661H83.8281V343.808V343.703H132.162V343.724V344.017Z",
    stroke: "#0C1356",
    strokeWidth: 0.86,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M83.7682 343.808V347.661H49.9258V343.766V343.703H83.7682V343.808Z",
    stroke: "#0C1356",
    strokeWidth: 0.86,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M126.83 132.125C129.908 153.611 133.51 177.359 133.761 181.988L51.543 181.841C51.8152 167.056 57.8256 125.653 61.281 104.355C61.281 103.748 61.4695 103.183 61.5533 102.617",
    stroke: "#0C1356",
    strokeWidth: 0.86,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M24.5908 64.2834C28.1509 59.1108 25.1562 50.3989 24.151 46.9434C23.5646 44.8492 20.528 45.0167 20.8421 47.9905C21.0934 50.5454 21.4494 53.247 20.4023 54.2731",
    stroke: "#0C1356",
    strokeWidth: 0.86,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M20.2557 54.6074C20.2651 54.552 20.2651 54.4953 20.2557 54.4399C18.2243 48.6808 11.6276 38.2098 8.21403 40.304C7.90841 40.4653 7.67559 40.7369 7.56281 41.0636C7.45002 41.3902 7.46572 41.7476 7.60671 42.0631C7.99743 42.9224 8.56055 43.6922 9.26114 44.3249C11.4671 46.2671 13.1883 48.6983 14.2872 51.4242",
    stroke: "#0C1356",
    strokeWidth: 0.86,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M7.49603 42.1305C7.12329 41.6416 6.64121 41.2467 6.08845 40.9776C5.53568 40.7085 4.92757 40.5726 4.31283 40.5808C3.89933 40.5578 3.49146 40.685 3.16435 40.939C2.83724 41.193 2.61293 41.5566 2.53276 41.9629C2.19769 43.0101 2.93066 43.8477 3.66363 44.5388C6.3499 47.2549 8.67925 50.302 10.5954 53.6067",
    stroke: "#0C1356",
    strokeWidth: 0.86,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M15.1822 68.6149C12.2503 68.2798 9.96758 61.4736 9.19272 59.2328C7.88231 55.9664 5.97954 52.9702 3.58025 50.3953C2.70068 49.3691 0.899665 47.6728 1.00438 46.2069C1.07366 45.9278 1.19969 45.6659 1.37461 45.4376C1.54953 45.2093 1.76959 45.0196 2.02108 44.8801C2.27257 44.7406 2.55009 44.6544 2.83635 44.6268C3.12261 44.5993 3.41149 44.631 3.68496 44.72",
    stroke: "#0C1356",
    strokeWidth: 0.86,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M16.1472 58.4339C15.3095 55.6695 18.6812 54.5177 20.3356 54.5806",
    stroke: "#0C1356",
    strokeWidth: 0.86,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M35.1914 94.1539L35.8406 93.5675C44.4241 85.6003 53.807 78.5404 63.8401 72.4998C70.1228 69.1072 80.3844 69.526 80.3844 69.526C80.5157 68.5618 80.8824 67.6447 81.4522 66.8558C82.022 66.0668 82.7772 65.4304 83.6513 65.0025L84.2586 64.7722C91.2742 62.8455 104.133 64.2277 105.745 65.212C107.096 66.2567 108.043 67.7366 108.426 69.4004C108.426 69.4004 125.535 71.9134 130.562 76.039C130.562 76.039 145.807 96.8764 153.43 113.232C156.236 119.242 155.168 122.928 150.059 125.797C146.98 127.556 137.033 129.986 126.75 131.703C114.625 133.797 102.059 135.263 99.9652 134.153C99.7786 134.055 99.6088 133.928 99.4626 133.776C97.7244 131.975 96.3841 125.965 98.3736 123.305C98.7738 122.781 99.3317 122.399 99.9652 122.216C108.74 119.682 118.017 117.588 124.614 116.059C127.672 115.368 130.143 114.782 131.734 114.321C127.399 109.295 125.661 106.782 122.834 103.201C122.834 103.201 123.399 107.096 124.593 116.017",
    stroke: "#0C1356",
    strokeWidth: 0.86,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M93.1688 121.643C91.9122 124.889 85.6506 124.324 82.9071 123.884C81.9438 123.737 78.0067 122.606 77.3156 120.847C77.3063 120.792 77.3063 120.735 77.3156 120.68",
    stroke: "#0C1356",
    strokeWidth: 0.86,
    strokeMiterlimit: 10
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M77.3381 120.864C77.0361 120.844 76.7335 120.89 76.4511 120.999C76.1687 121.108 75.9132 121.277 75.7022 121.494C75.4913 121.71 75.3298 121.971 75.229 122.256C75.1282 122.541 75.0904 122.845 75.1183 123.146C75.2228 123.851 75.494 124.521 75.9092 125.1C76.3244 125.679 76.8717 126.151 77.5057 126.476C80.5083 128.223 84.0336 128.846 87.4531 128.235",
    stroke: "#0C1356",
    strokeWidth: 0.86,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M77.468 126.491C77.19 126.43 76.9018 126.43 76.6239 126.492C76.346 126.554 76.085 126.676 75.8594 126.85C75.6338 127.023 75.449 127.244 75.3181 127.497C75.1871 127.75 75.1132 128.029 75.1016 128.313C75.2352 128.949 75.5148 129.544 75.9183 130.053C76.3217 130.562 76.8379 130.97 77.4261 131.245C80.4365 132.794 83.862 133.344 87.2061 132.816",
    stroke: "#0C1356",
    strokeWidth: 0.86,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M77.3842 131.299C77.1278 131.214 76.8552 131.19 76.5879 131.229C76.3207 131.268 76.0662 131.369 75.8446 131.523C75.6231 131.678 75.4406 131.882 75.3116 132.119C75.1826 132.356 75.1107 132.62 75.1016 132.89C75.1016 133.896 76.5256 135.152 79.0806 136.032C83.0948 137.219 87.3419 137.384 91.4364 136.513C94.0729 136.032 96.6547 135.289 99.143 134.293",
    stroke: "#0C1356",
    strokeWidth: 0.86,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M98.3668 123.516C98.7438 122.511 96.4192 119.683 93.6758 119.453",
    stroke: "#0C1356",
    strokeWidth: 0.86,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M76.0859 110.391L76.1278 110.747L77.2587 120.694L77.2796 120.82",
    stroke: "#0C1356",
    strokeWidth: 0.86,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M94.4678 110.391L94.4468 110.453L93.3997 119.417L93.1484 121.657",
    stroke: "#0C1356",
    strokeWidth: 0.86,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M76.1256 110.747C76.047 110.645 76.003 110.52 76 110.391C76 109.281 80.1884 108.297 85.2145 108.297C90.2406 108.297 94.4499 109.218 94.4499 110.391C94.3243 111.48 90.2615 112.36 85.2354 112.36C80.6491 112.422 76.8586 111.689 76.1256 110.747Z",
    stroke: "#0C1356",
    strokeWidth: 0.86,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M91.501 136.853L90.9146 142.172C88.9897 142.66 87.0153 142.927 85.0299 142.968C83.2078 142.952 81.3967 142.684 79.6478 142.172L79.0195 136.539",
    stroke: "#0C1356",
    strokeWidth: 0.86,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M23.3997 113.001C20.7401 97.755 17.3265 81.127 15.3789 68.6037L24.384 64.6875C25.7871 69.0644 31.9022 85.0851 35.7346 93.4828",
    stroke: "#0C1356",
    strokeWidth: 0.86,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M87.6616 105.583C88.1938 105.03 88.6033 104.371 88.8631 103.65C89.123 102.928 89.2274 102.159 89.1695 101.394C88.6608 100.204 88.0586 99.0552 87.3684 97.9597C86.0491 94.9441 87.3684 92.7451 89.4626 90.6719",
    stroke: "#0C1356",
    strokeWidth: 0.86,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M82.3582 105.583C82.8904 105.03 83.2999 104.371 83.5597 103.65C83.8196 102.928 83.924 102.159 83.8661 101.394C83.349 100.208 82.7471 99.0598 82.065 97.9597C80.7248 94.9441 82.065 92.7451 84.1592 90.6719",
    stroke: "#0C1356",
    strokeWidth: 0.86,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M112.329 327.984C109.418 329.115 99.7638 334.016 91.387 335C86.9892 335.503 83.785 337.094 83.8688 344.152",
    stroke: "#0C1356",
    strokeWidth: 0.86,
    strokeLinejoin: "round"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M97.1523 122.829C104.985 118.64 118.094 116.316 124.838 114.703",
    stroke: "#0C1356",
    strokeWidth: 0.86,
    strokeLinecap: "square",
    strokeLinejoin: "round"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M128.277 133.211L126.643 133.504C114.287 135.598 100.591 135.598 97.3242 133.986",
    stroke: "#0C1356",
    strokeWidth: 0.86,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIllustrationWavingGuy);
export default __webpack_public_path__ + "static/media/illustration-waving-guy.f5d6c8ccce99df85daf3934b38bab403.svg";
export { ForwardRef as ReactComponent };